import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { MenuItem } from '../shared/efaact-primeng.module';
import { LoggingService } from '../shared/services/logging/logging.service';
import * as fromUser from '../user-info/store/user.reducer';
import { IUserRole } from '../user-role/IUserRole';
import * as fromRole from '../user-role/store/reducers';
import { UserRoleComponent } from '../user-role/user-role.component';
import { IUser } from './IUser';

@Component({
    selector: 'ef-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    standalone: false
})
export class UserInfoComponent implements OnInit, OnDestroy {
    private userSub: Subscription;
    private roleSub: Subscription;
    public employeeName: string;
    public defaultRoleGroupID: number;
    public roleGroupName: string;
    private urStore: Store<fromRole.UserRoleState>;
    public urc: UserRoleComponent;
    @Input() public user: IUser;
    active = true;
    public menuItems: MenuItem[];
    public userRoles: IUserRole[];
    public roleItems: MenuItem[];
    constructor(
        private store: Store<fromUser.State>,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    ngOnDestroy(): void {
        this.userSub.unsubscribe();
        this.roleSub.unsubscribe();
        this.active = false;
    }

    ngOnInit() {
        this.urc = new UserRoleComponent(this.urStore, this.store, this.log);
        // this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.roleSub = this.store
            .pipe(
                takeWhile(() => this.active),
                select(fromRole.getUserRoles)
            )
            .subscribe(roles => {
                this.log.debug({
                    type: 'UserInfoComponent:role-subscribe',
                    roles
                });
                this.userRoles = roles;
                roles.forEach(role => {
                    if (role.RoleGroupID == this.defaultRoleGroupID) {
                        this.roleGroupName = role.GroupName;
                    }
                });
            });

        this.roleItems = this.rolesToItems(this.userRoles);

        this.userSub = this.store
            .pipe(
                takeWhile(() => this.active),
                select(fromUser.getUser)
            )
            .subscribe(user => {
                this.log.debug({
                    type: 'UserInfoComponent:user-subscribe',
                    user
                });
                this.user = user;

                if (user.userInfo.EmployeeName != null) {
                    this.employeeName = user.userInfo.EmployeeName;
                    this.defaultRoleGroupID = user.userInfo.DefaultRoleGroupID;

                    this.menuItems = [
                        {
                            label: this.employeeName,
                            items: [
                                {
                                    label: `User Role (this.roleGroupName)`,
                                    items: this.roleItems
                                },
                                {
                                    label: 'Logout'
                                    // command: () => this.urc.roleChosen(role.RoleGroupID)
                                }
                            ]
                        }
                    ];
                }
            });
    }

    public rolesToItems(roles) {
        const rolesAsItems: MenuItem[] = [];
        roles.forEach(role => {
            rolesAsItems.push({
                label: role.GroupName,
                command: () => this.urc.roleChosen(role.RoleGroupID)
            });
        });
        return rolesAsItems;
    }
}
